import React, { Component } from "react";
import DropDown from "../popup/DropDown";
import Select from "react-select";
import { Multiselect } from "multiselect-react-dropdown";
import Api from "../../Services/Api";
import { ifElse } from "ramda";

class DDLCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyData: [],
      // roleAccess: true,
      value: null,
    };
  }

  componentDidMount() {
    this.getCompany();
    // this.someFunction(this.props.value);
  }

  someFunction = (text) => {
    console.log("Message from parent: ", text);
    this.setState({
      value: text,
    });
  };

  getCompany() {
    let payload = {
      companyGroupId: "",
    };

    Api.create("MASTERDATA_EKSAD")
      .postGetCompany(payload)
      .then((res) => {
        if (res.ok && res.data.status === "S") {
          let array = [];

          if (this.props.all) {
            array.push({
              value: "ALL",
              label: "All Company",
            });
          }

          res.data.data &&
            res.data.data.map((item) => {
              array.push({
                value: item.companyId,
                label: item.companyName,
              });
            });
          this.setState({
            companyData: array,
          });
        }
      });
  }

  render() {
    const {
      label,
      mandatory,
      disabled,
      hierarchy,
      onChangeCombo,
      valueCombo,
      name,
      isLoading,
    } = this.props;
    return (
      <div className="margin-bottom-20px">
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {label} {mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>
        <Select
          style={{ backgroundColor: disabled && "#E6E6E6" }}
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 9999,
              fontFamily:
                "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
            }),
            control: (base) => ({
              ...base,
              fontFamily:
                "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
            }),
          }}
          isLoading={isLoading}
          isDisabled={
            !this.state.roleAccess ? disabled && true : this.state.roleAccess
          }
          options={this.state.companyData}
          onChange={(e) => {
            // this.someFunction(e);
            if (hierarchy == false) {
              if (name) {
                onChangeCombo({ [name]: e.value, [name + "Select"]: e });
              } else {
                onChangeCombo({
                  companyId: e.value,
                  ["companyId" + "Select"]: e,
                });
              }
            } else {
              onChangeCombo({
                companyId: e.value,
                ["companyId" + "Select"]: e,
                locationIdSelect: null,
                jobIdSelect: null,
                levelIdSelect: null,
                workingStatusIdSelect: null,
              });
            }
          }}
          value={valueCombo ?? null}
          {...this.props}
        />
      </div>
    );
  }
}

export default DDLCompany;
